module.exports = __webpack_public_path__ + "static/media/news_71-03.f37d717f.svg";